var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductBgHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 117,
    viewBox: "0 0 193 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321314597",
    clipPath: "url(#clip0_462_6629)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 117,
    fill: "#D7E0E7",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1321314500",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1321314499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M169.732 -38C135.699 -38 108 -10.3011 108 23.7317C108 57.7645 135.699 85.4634 169.732 85.4634C203.765 85.4634 231.463 57.7645 231.463 23.7317C231.463 -10.3011 203.765 -38 169.732 -38ZM230.34 23.7317C230.34 40.1573 223.754 55.0721 213.101 66.0161L209.575 62.4907C219.319 52.4572 225.342 38.7821 225.342 23.7317C225.342 8.68135 219.202 -5.26495 209.285 -15.3179L212.81 -18.8432C223.638 -7.87989 230.321 7.15113 230.321 23.7317H230.34ZM115.206 23.7317C115.206 -6.33028 139.65 -30.7751 169.712 -30.7751C199.774 -30.7751 224.219 -6.33028 224.219 23.7317C224.219 53.7937 199.774 78.2384 169.712 78.2384C139.65 78.2384 115.206 53.7937 115.206 23.7317ZM211.997 -19.618L208.471 -16.0927C198.438 -25.8551 184.763 -31.8791 169.693 -31.8791C154.623 -31.8791 140.967 -25.8551 130.934 -16.0927L127.409 -19.618C138.333 -30.2714 153.248 -36.8572 169.674 -36.8572C186.099 -36.8572 201.033 -30.2714 211.958 -19.5986L211.997 -19.618ZM126.595 -18.8238L130.12 -15.2985C120.184 -5.24556 114.043 8.56511 114.043 23.7704C114.043 38.9758 120.067 52.5153 129.83 62.5489L126.324 66.0742C115.651 55.1496 109.065 40.2155 109.065 23.7898C109.065 7.3642 115.767 -7.84115 126.595 -18.7851V-18.8238ZM127.118 66.8877L130.643 63.3624C140.696 73.2798 154.488 79.42 169.693 79.42C184.898 79.42 198.709 73.2798 208.762 63.343L212.287 66.8683C201.343 77.6961 186.293 84.3981 169.712 84.3981C153.132 84.3981 138.101 77.6961 127.157 66.8877",
    fill: "#C0CED9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1321314501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.238 -14.0563C192.121 -10.2257 191.416 -5.28022 193.281 -1.77067C197.069 5.35337 203.552 9.43094 207.594 16.7111C221.399 41.5893 194.774 45.7153 180.565 49.1173C172.53 51.0357 167.708 57.6649 173.802 69.364C197.025 67.4094 215.272 47.9363 215.272 24.2047C215.272 8.11496 206.881 -6.0167 194.238 -14.0598",
    fill: "#C0CED9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.684 5.77339C181.643 1.51854 175.479 -3.67918 174.834 -11.5009C174.558 -14.8376 176.455 -17.8946 179.259 -20.1553C173.376 -21.382 167.307 -21.429 161.405 -20.2935C155.504 -19.1579 149.886 -16.8625 144.877 -13.5401C148.245 -0.129066 160.965 1.27775 172.616 4.79259C189.26 9.81214 196.981 25.7616 173.962 28.3195C141.819 31.8917 138.022 39.8298 161.089 68.6568C163.408 69.1166 165.76 69.3938 168.122 69.4859C155.427 49.9977 162.467 44.5433 186.449 37.0982C209.785 29.8419 201.267 15.3459 187.683 5.77515",
    fill: "#C0CED9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.458 11.1654C149.589 9.38196 135.952 8.60755 132.174 2.46871C131.818 1.89023 131.502 1.28818 131.229 0.666748C126.908 7.75606 124.628 15.9004 124.64 24.2025C124.64 44.144 137.53 61.0849 155.431 67.1373C147.474 58.9284 134.362 49.2324 137.526 33.3887C139.643 22.8045 151.613 24.3498 161.01 23.5754C174.552 22.4623 173.109 13.6368 159.454 11.1654",
    fill: "#C0CED9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_462_6629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 117,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBgHover);
export default __webpack_public_path__ + "static/media/product_bg_hover.e9b4066cf7d111c37792bf9ae43c6ad2.svg";
export { ForwardRef as ReactComponent };